import '../style/css/components/staggeredFadeInDivEffect.css'

/** Sempre buscar a classe fade-enter
 * @time : tempo de delay na renderização entre um elemento e o próximo. Defaut = 50
 * @param time
 */
export function staggeredFadeInDivEffect(time){

	/** verifica se o argumento passado é um inteiro maior que zero, se não, setar o valor default
	 * e instanciando o tempo de renderização entre cada elemento
	 */
	if(!time > 0){
		time = 50
	}

	/** Resgatando todos os elementos na página que receberão o stagged fadein
	 * @type {HTMLCollectionOf<Element>}
	 */
	let targetElement = document.getElementsByClassName('fade-enter')

	/** Instanciando o tempo de renderização entre cada elemento
	 * @type {number}
	 */
	let stagger = time

	for(let divItem of targetElement){
		/** Armazendo as classes atuais do elemento
		 * @type {string}
		 */
		let currentClasses = divItem.getAttribute('class')

		setTimeout(()=>{
			/** Definindo as novas classes do elemento
			 * @type {string}
			 */
			divItem.className = currentClasses+'  fade-enter-active'
		},stagger)

		/** Adicionando o gap para a renderização do próximo elemento
		 * @type {number}
		 */
		stagger += time
	}
}
